module.exports = __webpack_public_path__ + "img/92.9.TU.5732a618.png";